import { addClass, removeClass } from './helpers/DOMHelper'
/**
 * class View
 */
class View {
  /**
   * constructor
   */
  constructor (el, onStateChange = () => {}) {
    this._state = ''
    this.onStateChange = onStateChange
    this.view = el
  }

  get state () { return this._state }
  set state (value) {
    if (value === this._state) return
    removeClass(this.view, this._state)
    this._state = value
    addClass(this.view, this._state)
    this.onStateChange(value)
  }

  on () {
    this.view.addEventListener(...arguments)
  }

  off () {
    this.view.removeEventListener(...arguments)
  }

  emit (eventString) {
    this.view.dispatchEvent(new CustomEvent(eventString))
  }

  showHandler (resolve) {
    // override me !
    resolve()
  }

  hideHandler (resolve) {
    // override me !
    resolve()
  }

  skip () {
    // override me !
  }

  show () {
    return new Promise(resolve => {
      this.showHandler(resolve)
      window.addEventListener('keypress', this.skipKeyCheck)
    })
  }

  hide () {
    return new Promise(resolve => {
      this.hideHandler(resolve)
    })
  }

  skipKeyCheck = e => {
    if (e.charCode === 83 && e.shiftKey) {
      window.removeEventListener('keypress', this.skipKeyCheck)
      this.skip()
    }
  }
}
export default View


// WEBPACK FOOTER //
// ./src/scripts/View.js